<template minapp="mpx" xlang="wxml">
  <controllable-drawer-bottom
    title="{{recommendTicketDrawer.title}}"
    show="{{show}}"
    bind:close="close"
  >
    <recommend-ticket-card
      recommendTicketDrawer="{{recommendTicketDrawer}}"
      wx:style="{{ {'padding-top': '37px', 'padding-bottom': '25px'} }}"
    />
    <view class="pay-container">
      <view class="price">
        <view class="order-money">
          <view class="order-money-type">￥</view>
          <view class="order-money-num">
            {{
              recommendTicketDrawer.afterPrice == recommendTicketDrawer.price
                ? recommendTicketDrawer.price
                : (recommendTicketDrawer.afterPrice || '0')
            }}</view
          >
        </view>
        <view class="discount-area" wx:if="{{recommendTicketDrawer.afterPrice != recommendTicketDrawer.price}}">
          <!-- 券透传信息 -->
          <view wx:if="{{recommendTicketDrawer.desc}}" class="discount-desc">{{
            recommendTicketDrawer.desc
          }}</view>
          <!-- 官方原价 -->
          <crossed-price class="original-price"price="{{Number(recommendTicketDrawer.price)}}" />
        </view>
      </view>
      <view class="btn" bindtap="toMakeOrder">预定</view>
    </view>
  </controllable-drawer-bottom>
  <!-- 百川授权弹窗 -->
  <Privacy
    wx:if="{{showPrivacy}}"
    list="{{baichuanTrainPrivacy}}"
    bind:privacyVerify="privacyVerify"
  />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { innerRouter, pagePath } from '@/common/jump'
  import dayjs from 'dayjs'

  createComponent({
    props: {
      recommendTicketDrawer: {
        type: Object,
        value: {}
      },
      show: {
        type: Boolean,
        value: false
      },
      trainInfo: {
        type: Object,
        value: {}
      }
    },
    data: {
      showPrivacy: false
    },
    computed: {
      ...store.mapState({
        trainDetail: 'train.trainDetail',
        baichuanTrainPrivacy: 'common.baichuanTrainPrivacy'
      })
    },
    methods: {
      ...store.mapMutations({
        setSelectSeatInfo: 'train.setSelectSeatInfo',
        setTrainDetail: 'train.setTrainDetail',
        setMakeOrderLoginType: 'makeOrder.setMakeOrderLoginType',
        setExpectTicket: 'train.setExpectTicket',
        setBaichuanTrainPrivacy: 'common.setBaichuanTrainPrivacy',
        setSupplierId: 'train.setSupplierId',
        setIsTransfer: 'train.setIsTransfer',
      }),
      close() {
        this.triggerEvent('close')
      },
      toMakeOrder() {
        if (this.baichuanTrainPrivacy?.title) {
          // 有待签署协议，需要展示签署弹窗
          return this.showPrivacy = true
        }
        this.setSupplierId(this.trainInfo?.supplier_id)
        const recommend = this.trainInfo.recommend_ticket?.[0]
        const trainInfoRecommend = {
          ...this.trainInfo,
          from_station_name: recommend.from_station_name,
          to_station_name: recommend.to_station_name,
        }
        if(this.trainInfo?.is_ticket_period && this.userGroup){
          this.setMakeOrderLoginType(1)
        }else{
          this.setMakeOrderLoginType(0)
        }
        this.setTrainDetail(trainInfoRecommend)
        const expectTicket = {
          ...trainInfoRecommend,
          expect_from_station: this.trainInfo.from_station_name,
          expect_to_station: this.trainInfo.to_station_name,
          diff_station_num: recommend.diff_station_num,
          diff_amount: recommend.diff_amount,
          type: recommend.type,
          expect_start_time: dayjs(this.trainInfo.start_time).unix(),
          expect_arrive_time: dayjs(this.trainInfo.arrive_time).unix()
        }
        this.setExpectTicket(expectTicket)
        this.setSelectSeatInfo([recommend])
        this.setIsTransfer(false)
        this.close()
        innerRouter.push(pagePath().MAKEORDERBACKUP, {
          isRecommend: true
        })
      },
      privacyVerify(val) {
        const isComfirm = val.detail
        this.showPrivacy = false
        if (isComfirm) {
          this.setBaichuanTrainPrivacy({})
        }
      },
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .recommend-drawer
    // display flex
    padding 37px 16px 24px
    font-family PingFang SC
    font-size 14px
    font-weight 500
    color #222222
  .info
    display flex
    align-items center
    justify-content space-between
    width 100%
    margin-bottom 21px
  .left
    display flex
    align-items center
  .tag
    background #338FFF
    margin-right 8px
    border-radius 4px
    color #FFFFFF
    font-size 12px
    padding 3.5px 5px
  .tips
    padding 10px 12px
    font-size 12px
    background #F2F6F9
    border-radius 12px
    margin-top 20px
  .pay-container
    height 100px
    padding 11px 14px 0 16px
    box-shadow inset 0px 1px 0px 0px #EEEEEE
    border-radius 10px 10px 0px 0px
    display flex
    justify-content space-between
    align-items baseline
  .price
    color #FF6400
    font-size 32px
    font-weight 500
    display flex
    align-items baseline
    flex-direction column
    font-family Barlow Semi Condensed
    font-weight 400
    &-symbol
      font-size 16px
      font-weight normal
    .discount-area
      display flex
      margin-top 4px
      align-items center
      .discount-desc
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #FF6400
        margin-right 4px
      .original-price
        font-family PingFangSC-Regular
        font-size 10px
        font-weight normal
        line-height 10px
        color #999
  .btn
    width 140px
    height 50px
    background #FF6400
    color #FFFFFF
    font-size 16px
    font-weight 800
    display flex
    align-items center
    justify-content center
    border-radius 10px
  .order-money
    line-height 32px
    display flex
    align-items flex-end
    color #FF6400
    .order-money-type
      font-family PingFangSC-Semibold
      font-size 16px
      line-height 16px
      transform translateY(-4px)
    .order-money-num
      font-family Barlow Semi Condensed
      font-size 32px
      font-weight 400
      &-personal
        color #FF7D41
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'controllable-drawer-bottom': '@/components/controllable-drawer-buttom',
      'recommend-ticket-card': './recommend-ticket-card',
      'crossed-price': '@/components/crossed-price',
      'Privacy': '@/pages/train-detail/components/privacy',
    }
  }
</script>